import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable, Subject} from "rxjs";
import {TransactionSearchCriteria} from "../model/transaction.search.criteria";
import {WalletTransactionRequestDto} from "../model/wallet.transaction.request.dto";
import {WalletTransactionDto} from "../model/wallet.transaction.dto";

@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  constructor(private http: HttpClient) {
  }
  private refreshCountSource = new Subject<void>();
  refreshCount$ = this.refreshCountSource.asObservable();

  transactionCountRefresh() {
    this.refreshCountSource.next();
  }

  getTransactionsCount(transactionSearchCriteria: TransactionSearchCriteria): Observable<HttpResponse<number>> {
    return this.http.post<number>('/app/transactions/count', transactionSearchCriteria, {observe: "response"})
  }

  searchTransactions(transactionSearchCriteria: TransactionSearchCriteria): Observable<HttpResponse<WalletTransactionDto[]>> {
    return this.http.post<WalletTransactionDto[]>('/app/transactions/search', transactionSearchCriteria, {observe: "response"})
  }

  getAdvanceReceipt(transactionId: string): Observable<ArrayBuffer> {
    return this.http.get(`/app/transactions/${transactionId}/advanceReceipt`, {
      responseType: 'arraybuffer',
      observe: 'body'
    })
  }

}
